"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApsService = void 0;
const axios_1 = require("axios");
const cockatiel_1 = require("cockatiel");
class ApsService {
    constructor(config) {
        this.retryPolicy = this.createRetryPolicy(config);
        this.circuitBreakerPolicy = this.createCircuitBreakerPolicy(config);
        this.timeoutPolicy = this.createTimeoutPolicy(config);
        this.resiliencePolicy = (0, cockatiel_1.wrap)(this.circuitBreakerPolicy, this.retryPolicy, this.timeoutPolicy);
    }
    createRetryPolicy(config) {
        return (0, cockatiel_1.retry)((0, cockatiel_1.handleType)(axios_1.AxiosError, (err) => { var _a; return ApsService.RETRYABLE_STATUS_CODES.includes((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status); }).orWhen((err) => {
            // check if err quacks like an ISDKError
            return ('httpStatusCode' in err &&
                err.httpStatusCode instanceof Function &&
                ApsService.RETRYABLE_STATUS_CODES.includes(err.httpStatusCode()));
        }), {
            maxAttempts: config.retryCount,
            backoff: new cockatiel_1.ExponentialBackoff({
                maxDelay: config.backoffInterval
            })
        });
    }
    createCircuitBreakerPolicy(config) {
        return (0, cockatiel_1.circuitBreaker)(cockatiel_1.handleAll, {
            breaker: new cockatiel_1.ConsecutiveBreaker(config.retryCount),
            halfOpenAfter: config.circuitBreakerInterval
        });
    }
    createTimeoutPolicy(config) {
        return (0, cockatiel_1.timeout)(config.timeOutValue, cockatiel_1.TimeoutStrategy.Aggressive);
    }
    request(config) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.resiliencePolicy.execute(() => axios_1.default.request(config));
        });
    }
}
exports.ApsService = ApsService;
ApsService.RETRYABLE_STATUS_CODES = [408, 429, 502, 503, 504];
